import { createMedia } from "@artsy/fresnel";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Container,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
  Image,
  Input,
  Loader,
  Message,
  Popup,
  Segment,
  Select,
} from "semantic-ui-react";
import NextLevel from "../components/NextLevel";
import { chatLC, fetchTopicList } from "../redux/actions/actions";

const { MediaContextProvider, Media } = createMedia({
  // breakpoints values can be either strings or integers
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  },
});
const levelOptions = [
  { key: "hard", text: "上", value: "hard" },
  { key: "mid", text: "中", value: "mid" },
  { key: "easy", text: "下", value: "easy" },
];


export class AIChat_cn extends Component {
  state = {
    topicModalOpen: false,
    selectedTopic: "School",
    selectedDifficulty: "hard",
  };
  componentDidMount() {
    this.props.dispatch(fetchTopicList());
  }
  render() {
    if (this.props.data.fetchingTopicList) {
      return <Loader active />;
    }
    return (
      <>
        <div style={{ backgroundColor: "#f1f1f1" }}>
          <Container textAlign="center" style={{ paddingTop: "3em" }}>
            <Header as="h3">MUSE API 02</Header>
            <Header as="h1" style={{ fontSize: "48px" }}>
            MUSE AIチャットAPI
            </Header>
            {/* <p>지금 MUSE AI Chat API를 체험해 보세요</p> */}
          </Container>

          <Container style={{ padding: "2em" }}>
            <Segment raised style={{}}>
              <Form>
                <Form.Group widths="equal">
                  <Form.Field
                    required
                    defaultValue="hard"
                    control={Select}
                    options={levelOptions}
                    label="難易度"
                    placeholder="Select difficulty"
                    onChange={(e, v) => {
                      console.log(v.value);
                      this.setState({ selectedDifficulty: v.value });
                    }}
                  />
                  <Form.Field
                    required
                    defaultValue="School"
                    control={Select}
                    options={this.props.data.topicDropdownOptions}
                    label="トピック"
                    placeholder="Select topic"
                    onChange={(e, v) => {
                      console.log(v.value);
                      this.setState({ selectedTopic: v.value });
                    }}
                  />
                </Form.Group>
              </Form>

              <div>
                <Grid>
                  <Grid.Row columns={2} divided>
                    <Grid.Column>
                      <div
                        ref={this.handleContextRef}
                        style={{ paddingTop: 20 }}
                      >
                        <Grid>
                          {this.props.data.chatHistory.map((el, idx) => {
                            return (
                              <Grid.Row key={`conversation_${idx}`}>
                                <Grid.Column>
                                  <Segment
                                    style={{ padding: 10 }}
                                    inverted
                                    color={
                                      el.sender === "bot" ? "green" : "blue"
                                    }
                                    floated={
                                      el.sender === "bot" ? "left" : "right"
                                    }
                                  >
                                    <div>{el.msg}</div>
                                  </Segment>
                                </Grid.Column>
                              </Grid.Row>
                            );
                          })}
                        </Grid>
                      </div>
                    </Grid.Column>

                    <Grid.Column>
                      <div>
                        <Segment basic>
                          <Header>
                          返事
                            <Header.Subheader>
                            保存されません
                            </Header.Subheader>
                          </Header>

                          <Button
                            onClick={() => {
                              this.props.dispatch(
                                chatLC(
                                  null,
                                  "hi",
                                  this.state.selectedTopic,
                                  this.state.selectedDifficulty,
                                  "rammi_test"
                                )
                              );
                            }}
                            fluid
                            inverted
                            color="orange"
                            disabled={
                              this.props.data.topicDropdownOptions.length === 0
                            }
                          >
                            新しいセッションを始める
                          </Button>

                          {this.props.data.lastBotUttId &&
                            this.props.data.suggestedResponses &&
                            this.props.data.suggestedResponses.length > 0 && (
                              <Header>Suggested Responses</Header>
                            )}
                          {this.props.data.suggestedResponses.map((el, idx) => {
                            return (
                              <Popup
                                key={`popup_suggestion_${idx}`}
                                trigger={
                                  <Segment
                                    onClick={() => {
                                      if (
                                        this.props.data.chatHistory.length < 10
                                      ) {
                                        this.props.dispatch(
                                          chatLC(
                                            this.props.data.lastBotUttId,
                                            el.text,
                                            this.state.selectedTopic,
                                            this.state.selectedDifficulty,
                                            "rammi_test"
                                          )
                                        );
                                      }
                                    }}
                                    key={`suggestion_${idx}`}
                                    inverted
                                    color={
                                      this.props.data.chatHistory.length < 10
                                        ? "teal"
                                        : "grey"
                                    }
                                  >
                                    <div>{el.text}</div>
                                  </Segment>
                                }
                                inverted
                                position="right center"
                                content="In the actual usage case, students would be prompted to speak this out loud."
                              />
                            );
                          })}
                          <Divider />
                          <Message
                            error={this.props.data.chatHistory.length > 8}
                          >
                            詳細はお問い合わせください
                          </Message>
                          {false && <Header>Write your own response</Header>}

                          {false && (
                            <Segment inverted color="blue">
                              <div>
                                <Input
                                  fluid
                                  action
                                  attached="top"
                                  onChange={(e, v) => {
                                    const value = v.value.replace("\n", " ");
                                    this.setState({ body: v.value });
                                  }}
                                  placeholder="Your reply"
                                >
                                  <input />
                                  <Button
                                    onClick={() => {
                                      this.props.dispatch(
                                        chatLC(
                                          this.props.data.lastBotUttId,
                                          this.state.body,
                                          this.state.selectedTopic,
                                          this.state.selectedDifficulty,
                                          "rammi_test"
                                        )
                                      );
                                    }}
                                  >
                                    <Icon name="send" />
                                  </Button>
                                </Input>
                              </div>
                            </Segment>
                          )}
                        </Segment>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Segment>
          </Container>
        </div>
        <Divider hidden />
        <Divider hidden />
        <Header as="h1" textAlign="center" style={{ fontSize: "48px" }}>
        Muse AIチャットAPI
        </Header>
        <Divider hidden />
        <Divider hidden />

        <div style={{ padding: 50 }}>
          <Grid container stackable verticalAlign="top">
            <Grid.Row columns={4}>
              <Grid.Column style={{marginLeft:"10%", marginBottom:"10%"}}>
                <Image width="90px" height="90px" src="/chat1.png" />
                <Header style={{fontSize:"28px"}}>学習者のチャットAPI</Header>
                <p style={{fontSize:"24px"}}>
                AIが返事を提案する、Corpus（コーパス）ベースの協力型会話システム{" "}
                </p>
              </Grid.Column>
              <Grid.Column style={{marginLeft:"30%"}}>
                <Image width="90px" src="/chat2.png" />
                <Header style={{fontSize:"28px"}}>イージーモードチャットAPI</Header>
                <p style={{fontSize:"24px"}}>
                  学習教材（本など）ベースのAI会話エンジン
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider hidden />

          <Grid container stackable verticalAlign="top">
            <Grid.Row columns={4}>
              <Grid.Column style={{marginLeft:"10%"}}>
                <Image width="90px" height="90px" src="/chat3.png" />
                <Header style={{fontSize:"28px"}}>Eduモード教育API</Header>
                <p style={{fontSize:"24px"}}>
                リアルタイムのフィードバックができるカリキュラムベースの繰り返し学習システム
                </p>
              </Grid.Column>
              <Grid.Column style={{marginLeft:"30%"}}>
                <Image width="90px" height="90px" src="/chat4.png" />
                <Header style={{fontSize:"28px"}}>話された文章の中で重要な単語を抽出します</Header>
                <p style={{fontSize:"24px"}}>
                文章の中で重要な単語・パーツ（お名前や地名など）を抽出します
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <Divider hidden />
        <Divider hidden />
        <NextLevel />
      </>
    );
  }
}

AIChat_cn = connect((store) => {
  return {
    data: store.launcherapi,
  };
})(AIChat_cn);
